<template>
  <div>
    <v-dialog v-model="isActive" persistent max-width="1000px">
      <v-card class="elevation-0">
        <v-card-text class="py-5">
          <form>
            <v-layout wrap row>
              <v-flex
                xs12
                sm6
                class="form-control pa-1"
                :class="{ 'has-error': errors.has('phone') }"
              >
                <label>{{ $t('Phone') }}</label>
                <input
                  v-model="userInfo.phone_no"
                  class="form-control"
                  type="text"
                  name="phone"
                  :data-vv-as="$t('Phone')"
                  v-validate="{
                    required: true,
                    regex: phoneRegex,
                  }"
                  @input="handleInputPhone"
                />
                <span class="text-error" v-if="errors.has('phone')">
                  {{ errors.first('phone') }}
                </span>
              </v-flex>
              <v-flex
                xs12
                sm6
                class="form-control pa-1"
                :class="{ 'has-error': errors.has('email') }"
              >
                <label>{{ $t('Email') }}</label>
                <input
                  v-model="userInfo.email"
                  class="form-control"
                  type="text"
                  name="email"
                  :data-vv-as="$t('Email')"
                  v-validate="'required|email'"
                />
                <span class="text-error" v-if="errors.has('email')">
                  {{ errors.first('email') }}
                </span>
              </v-flex>
            </v-layout>
          </form>
          <div class="mt-4 mb-3" style="align-items: center" v-if="!userInfo.hide_is_interested_demo">
            <label>{{ $t('Would you like to get more info via online session with {team} team?', { team: 'ZWIZ.AI' }) }}</label>
            <v-radio-group
              v-model="userInfo.is_interested_demo"
              class="text-xs-center mt-1"
              color="primary"
              hide-details
              row
            >
              <v-radio color="primary" :label="$t('interest')" :value="true"></v-radio>
              <v-radio color="primary" :label="$t('not_interest')" :value="false"></v-radio>
            </v-radio-group>
          </div>
          <div class="d-flex mb-4" style="align-items: center">
            <v-checkbox
              class="mt-0"
              v-model="userInfo.isChecked"
              color="primary"
              style="width: fit-content; flex: 0 1 auto !important"
              hide-details
            >
            </v-checkbox>
            <span @click="userInfo.isChecked = !userInfo.isChecked">
              {{ $t('Acknowledge and consent ZWIZ.AI') }}
              <span class="primary--text" style="cursor: pointer" @click.stop="showTerms = true">
                {{ $t('Term&Condition') }}
              </span>
              <span class="mx-1">{{ $t('and') }}</span>
              <span class="primary--text" style="cursor: pointer" @click.stop="showPrivacy = true">
                {{ $t('Privacy Policy') }}
              </span>
            </span>
          </div>
          <div class="d-flex justify-center">
            <v-btn
              class="mx-auto"
              style="max-width: fit-content"
              color="primary"
              :disabled="!userInfo.isChecked"
              :loading="isLoading"
              @click="submitConcent()"
            >
              {{ $t('Proceed') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <privacy-and-policy v-model="showPrivacy" />
    <term-and-condition v-model="showTerms" />
  </div>
</template>

<script>
import api from '@/api'

import PrivacyAndPolicy from '../view/getstarted/PrivacyAndPolicy'
import TermAndCondition from '../view/getstarted/TermAndCondition'
export default {
  components: { PrivacyAndPolicy, TermAndCondition },
  data: () => ({
    showPrivacy: false,
    showTerms: false,
    isLoading: false,
  }),
  props: {
    value: {
      type: Boolean,
    },
    payload: {
      type: Object,
      default: () => ({
        phone_no: '',
        email: '',
        isChecked: false,
        is_interested_demo: false,
        hide_is_interested_demo: false,
      }),
    },
  },
  computed: {
    isActive: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    phoneRegex() {
      if (this.$store.state.pagePhoneNumberlaos.includes(this.$store.state.selectedBot.pageid)) {
        // return /^[+]{1}[1-9]{1}[0-9]{0,2}[1-9]{2}[0-9]{8,9}$|^[0-9]{3,4}$/
        return /^[+]?[0-9]{9,}$/
      } else {
        return /^[+]?[0-9]{9,}$/
      }
    },
    userInfo: {
      get() {
        return this.payload
      },
      set(value) {
        this.$emit('update:payload', value)
      },
    },
  },
  methods: {
    async submitConcent() {
      const result = await this.$validator.validateAll()
      if (!result) {
        this.goToErrorInput()
        return false
      } else {
        this.isLoading = true
        const payload = { phone_no: this.payload.phone_no, email: this.payload.email, is_interested_demo: this.payload.hide_is_interested_demo ? undefined : this.payload.is_interested_demo }
        api.saveAdminPageInfo(payload, async (error, response) => {
          if (error) {
            this.isLoading = false
            this.$swal({
              title: this.$t('Unsuccessful'),
              type: 'error',
              text: response.data && response.data.message ? response.data.message : '',
              confirmButtonText: this.$t('Confirm'),
            })
          } else {
            await this.$swal({
              title: this.$t('Success'),
              type: 'success',
              confirmButtonText: this.$t('Confirm'),
              timer: 1500
            })
            this.isLoading = false
            this.$emit('success', true)
          }
        })
      }
    },
    handleInputPhone(event) {
      const val = event.target.value
      this.$nextTick(() => {
        this.userInfo.phone_no = val ? val.replace(/[^0-9+]/g, '') : ''
      })
    }
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/elements/PopupVerifyUserInfo.vue